var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x9D\xBC\xEB\x94\x94\xEC\x98\xA4 \xEB\xB2\x84\xED\x8A\xBC=\xED\x99\x9C\xEC\x84\xB1\xED\x99\x94"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 256",
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#825DFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 10,
    cy: 10,
    r: 5,
    fill: "#825DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioActive);
export default __webpack_public_path__ + "static/media/radio-active.c9f31326d772a692053a8cde51bbfdf0.svg";
export { ForwardRef as ReactComponent };